// @core/api/endpoints/form/list_form_templates.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListFormTemplatesResponse,
} from '../../../types/form';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/form';

/**
 * List form templates
 * Returns all available form templates. Supports filtering by category and public visibility.
 */
export async function ListFormTemplates(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListFormTemplatesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/forms/templates`;
  const requestOptions = options;
  return client.get<ListFormTemplatesResponse>(requestPath, { ...requestOptions, params });
}
